/**
 * backend-api
 * LoopBack Application
 *
 * OpenAPI spec version: 5.38.4
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ObjectID from './ObjectID';

/**
* The Localization model module.
* @module model/Localization
* @version 5.38.4
*/
export default class Localization {
    /**
    * Constructs a new <code>Localization</code>.
    * @alias module:model/Localization
    * @class
    * @param locale {String} 
    */

    constructor(locale) {
        
        
        this['locale'] = locale;
        
    }

    /**
    * Constructs a <code>Localization</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/Localization} obj Optional instance to populate.
    * @return {module:model/Localization} The populated <code>Localization</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Localization();
                        
            
            if (data.hasOwnProperty('locale')) {
                obj['locale'] = ApiClient.convertToType(data['locale'], 'String');
            }
            if (data.hasOwnProperty('city')) {
                obj['city'] = ApiClient.convertToType(data['city'], 'String');
            }
            if (data.hasOwnProperty('language')) {
                obj['language'] = ApiClient.convertToType(data['language'], 'String');
            }
            if (data.hasOwnProperty('country')) {
                obj['country'] = ApiClient.convertToType(data['country'], Object);
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ObjectID.constructFromObject(data['id']);
            }
        }
        return obj;
    }

    /**
    * @member {String} locale
    */
    locale = undefined;
    /**
    * @member {String} city
    */
    city = undefined;
    /**
    * @member {String} language
    */
    language = undefined;
    /**
    * @member {Object} country
    */
    country = undefined;
    /**
    * @member {module:model/ObjectID} id
    */
    id = undefined;




}
